import { SimpleObject } from '../entities/simple-object';

interface Parameters {
  [key: string]: SimpleObject;
}

const backendBaseUrl = process.env.REACT_APP_API_BASE_URL || 'https://api.allergomedica.lt';
const appWebsiteUrl = process.env.REACT_APP_WEBSITE_URL || 'https://app.allergomedica.lt';

const backendBaseUrlPL = process.env.REACT_APP_API_BASE_URL_PL || 'https://api.allergomedica.pl';
const appWebsiteUrlPL = process.env.REACT_APP_WEBSITE_URL_PL || 'https://allergomedica.pl';

const backendBaseUrlLv = process.env.REACT_APP_API_BASE_URL_LV || 'https://api.allergomedica.lv';
const appWebsiteUrlLv = process.env.REACT_APP_WEBSITE_URL_LV || 'https://allergomedica.lv';

const backendBaseUrlSelfco = process.env.REACT_APP_API_BASE_URL_SELFCO || 'https://api.self.co';
const appWebsiteUrlSelfco = process.env.REACT_APP_WEBSITE_URL_SELFCO || 'https://partners.self.co';

export const parametersValues: Parameters = {
  allergomedica: {
    lt: {
      isDevelopment: process.env.NODE_ENV === 'development',
      api: {
        baseUrl: backendBaseUrl,
        websiteUrl: appWebsiteUrl,
      },
    },
    pl: {
      isDevelopment: process.env.NODE_ENV === 'development',
      api: {
        baseUrl: backendBaseUrlPL,
        websiteUrl: appWebsiteUrlPL,
      },
    },
    lv: {
      isDevelopment: process.env.NODE_ENV === 'development',
      api: {
        baseUrl: backendBaseUrlLv,
        websiteUrl: appWebsiteUrlLv,
      },
    },
  },
  selfco: {
    en: {
      isDevelopment: process.env.NODE_ENV === 'development',
      api: {
        baseUrl: backendBaseUrlSelfco,
        websiteUrl: appWebsiteUrlSelfco,
      },
    },
  },
};
